import { render, staticRenderFns } from "./information.vue?vue&type=template&id=7fd2c1d6&scoped=true&"
import script from "./information.vue?vue&type=script&lang=js&"
export * from "./information.vue?vue&type=script&lang=js&"
import style0 from "./information.vue?vue&type=style&index=0&id=7fd2c1d6&prod&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fd2c1d6",
  null
  
)

export default component.exports